const ChoosePostOfficeIcon = () => (
  <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="post-office-icon-grad" x1="11.5" y1="-2.00018" x2="-5" y2="22.4998" gradientUnits="userSpaceOnUse">
        <stop stopColor="var(--s247-icon-start, #AC2B90)"/>
        <stop offset="1" stopColor="var(--s247-icon-end, #EE5B33)"/>
      </linearGradient>
    </defs>
    <path d="M7.5 0.791504C9.38967 0.791504 11.2019 1.54217 12.5381 2.87837C13.8743 4.21456 14.625 6.02684 14.625 7.9165C14.625 10.8663 12.3767 13.9569 7.975 17.2582C7.83797 17.3609 7.67129 17.4165 7.5 17.4165C7.32871 17.4165 7.16203 17.3609 7.025 17.2582C2.62333 13.9569 0.375 10.8663 0.375 7.9165C0.375 6.02684 1.12567 4.21456 2.46186 2.87837C3.79806 1.54217 5.61033 0.791504 7.5 0.791504ZM7.5 5.5415C6.87011 5.5415 6.26602 5.79173 5.82062 6.23713C5.37522 6.68252 5.125 7.28661 5.125 7.9165C5.125 8.54639 5.37522 9.15048 5.82062 9.59588C6.26602 10.0413 6.87011 10.2915 7.5 10.2915C8.12989 10.2915 8.73398 10.0413 9.17938 9.59588C9.62478 9.15048 9.875 8.54639 9.875 7.9165C9.875 7.28661 9.62478 6.68252 9.17938 6.23713C8.73398 5.79173 8.12989 5.5415 7.5 5.5415Z" fill="url(#post-office-icon-grad)"/>
  </svg>
);
import Section from 'Components/Section';
import { ChoosePostOfficeTextEnum } from 'Pages/ChoosePostOffice/enums';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SelectPointModel } from 'Services/v1/c2c-over-payment/models';
import {
  c2cOrderPaymentSelectors,
  selectReceiverPointAction,
  selectSenderPointAction
} from 'Stores/c2c-order-payment';
import { PostOfficeItem } from '..';
import './styles.scss';

const PostOfficeList = (props: { list: SelectPointModel[]; type: string }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { selectReceiverPoint, selectSenderPoint } = useSelector(
		c2cOrderPaymentSelectors.get,
	);

	const checkChecked = (item: SelectPointModel) => {
		if (props.type === 'sender') {
			return selectSenderPoint.id === item.id;
		} else if (props.type === 'receiver') {
			return selectReceiverPoint.id === item.id;
		}
		return false;
	};
	const renderPostOffice = () => {
		return props.list?.map((item, i) => {
			return (
				<PostOfficeItem
					key={i}
					onSelectedPostOffice={(e: SelectPointModel) => {
						if (props.type === 'sender') {
							dispatch(selectSenderPointAction(e));
						} else if (props.type === 'receiver') {
							dispatch(selectReceiverPointAction(e));
						}
						navigate('/c2c-order-payment');
					}}
					checked={checkChecked(item)}
					item={item}
				></PostOfficeItem>
			);
		});
	};
	return (
		<Section
			title={t(ChoosePostOfficeTextEnum.CPO_PostOfficeList_Title)}
			icon={<ChoosePostOfficeIcon />}
			className="post-office-list"
		>
			{props?.list && renderPostOffice()}
		</Section>
	);
};

export default PostOfficeList;
